module.exports = __webpack_public_path__ + "images/mobile/img-error-404-889f04fd3096048caafb1014325c0458.png";